import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet-async";

const Collections = () => {

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    // Preloader timer
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get("https://kskrishnasilver.com/api/category.php")
            .then((res) => {
                if (Array.isArray(res.data)) {
                    setCategories(res.data);
                } else if (res.data.data) {
                    setCategories(res.data.data);
                }
            })
            .catch((err) => console.error(err));
    }, []);

    return (
        <>
            {loading && (
                <div className="loader-wrapper">
                    <div className="ring-loader"></div>
                </div>
            )}
            <Header />
            <Helmet>
                <title>
                    {`Collection | Krishna Silver | ${process.env.REACT_APP_PHONE}`}
                </title>
            </Helmet>

            <div className="collection-page">
                <div className="collection-hero">
                    <h1><Link to="/">Home</Link> <span> ~ </span> <Link className="activepage" to="/collections">Our Collections</Link></h1>
                </div>
            </div>

            <section className="categories">
                <div className="container">
                <div className="category-grid">

                    {categories.map((item, index) => (

                        <div className="category-card" key={index}>

                            <div className="card-inner">

                                <img
                                    src={`https://kskrishnasilver.com/uploads/category/${item.img}`}
                                    alt={item.name}
                                />

                                <div className="category-overlay">

                                    <h3>{item.name}</h3>

                                    <Link to={`/collection/${item.slug}`}>
                                        <button className="view-btn">View Collection</button>
                                    </Link>

                                </div>

                            </div>

                        </div>

                    ))}

                </div>
                    </div>
            </section>

            <Footer />
        </>
    );
};

export default Collections;